import { useCallback, useMemo } from 'react';
import { captureException } from '../utils/sentryUtils';
import { useGetApprovalConfigurationQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
export const useApprovalConfig = (approvalType, approvalAction) => {
  const {
    data: chirpData,
    loading: chirpLoading,
    error: chirpError,
    refetch: chirpRefetch
  } = useGetApprovalConfigurationQuery({
    variables: {
      approvalType,
      approvalAction
    },
    // fetchPolicy 'network-only' ensures fresh data. If removing this need to test extensively
    fetchPolicy: 'network-only',
    onError: error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalConfig-chirp',
          approvalType,
          approvalAction
        }
      });
    }
  });
  const config = useMemo(() => {
    if (!chirpData) {
      // If we cannot get a response from config endpoint, we will set approvals to enabled:false
      const enabled = chirpError ? false : null;
      return {
        approvalAction,
        approvalType,
        enabled,
        portalId: null
      };
    }
    const {
      approvalConfiguration
    } = chirpData;
    return {
      // We already have the approvalAction and approvalType so don't need to use the chirp values,
      // this also avoids the TS error from unhandled enum case. In future I want to remove all FE types tho
      approvalAction,
      approvalType,
      enabled: approvalConfiguration.enabled,
      portalId: approvalConfiguration.portalId
    };
  }, [chirpData, chirpError, approvalAction, approvalType]);
  const fetchConfig = useCallback(() => {
    void chirpRefetch();
  }, [chirpRefetch]);
  return useMemo(() => ({
    config,
    fetchConfig,
    isLoading: chirpLoading
  }), [config, fetchConfig, chirpLoading]);
};